import TableCategoryAccessPolicies from '../../../components/table/companies/TableCategoryAccessPolicies'

const UserProtocolBookPermissionsPage = () => {
  return (
    <div className="w-full flex flex-col gap-6 pb-10">
      <TableCategoryAccessPolicies />
    </div>
  )
}

export default UserProtocolBookPermissionsPage
